import React from 'react';
import { Modal, Flex } from 'antd';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

interface ShareJobPostProps {
  visible: boolean;
  onClose: () => void;
  orgDomain: string;
}

const ShareJobPost: React.FC<ShareJobPostProps> = ({
  visible,
  onClose,
  orgDomain,
}) => {
  const shareUrl = `https://${orgDomain}`;

  return (
    <Modal
      title="Share Job Post"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      <Flex gap={16} justify="center" align="center">
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <LinkedinShareButton url={shareUrl}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </Flex>
    </Modal>
  );
};

export default ShareJobPost;
